/* eslint-disable no-unused-vars */
import { Tooltip, Menu, Divider } from 'antd';
import DokanIcons from '../icon/DokanIcons';

function DokanOrderCard({ hasTitle, Title, hasDivider, children }) {
    return (
        <>
            <div className="bg-white rounded-sm mt-30px border border-primary">
                <div className="flex justify-between items-center">
                    <div className="flex gap-3 px-8 pt-4 items-center">
                        {hasTitle && (
                            <div className="">
                                <h3 className="text-dark text-md font-bold">{Title}</h3>
                            </div>
                        )}
                    </div>
                </div>
                {hasDivider && <Divider />}
                <div>{children}</div>
            </div>
        </>
    );
}

export default DokanOrderCard;
